import { IconButton, Typography, Theme } from '@mui/material';

export const HistoryButton = ({
  text,
  icon,
  onClick,
}: {
  text: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <IconButton
      id="basic-button"
      onClick={onClick}
      sx={(theme: Theme) => ({
        padding: '10px 44px',
        border: '1px solid',
        borderColor: theme.palette.gray[150],
        borderRadius: '100px',
        display: 'flex',
        gap: '6px',
      })}
    >
      {icon}
      <Typography variant="body2" color="common.white">
        {text}
      </Typography>
    </IconButton>
  );
};
